export default "__VITE_ASSET__BjKLkpp6__"